module.exports = __webpack_public_path__ + "static/media/varais-13-copia.53130e8d.jpg";